// Fancybox
$('.fancybox1').fancybox({
	type: 'iframe',
	iframe: {
		css: {
			width: '768px',
		},
	},
	smallBtn: true,
})

// Datepicker
$('input.datepicker-input').daterangepicker(
	{
		singleDatePicker: true,
		showDropdowns: true,
		autoApply: true,
		minDate: '01/01/1900',
		locale: {
			format: 'DD.MM.YYYY',
			fromLabel: 'Od',
			toLabel: 'Do',
			daysOfWeek: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
			monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
			firstDay: 1,
		},
	},
	function (chosen_date) {
		$('input.datepicker-input').val(chosen_date.format('DD.MM.YYYY'))
	},
	function (start, end, label) {
		console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')')
	},
)

// Multiple select
$('.multiple-select').multipleSelect({
	formatSelectAll: function () {
		return 'Vybrat vše'
	},
	formatAllSelected: function () {
		return 'Vybráno vše'
	},
	formatCountSelected: function (count, total) {
		return 'Vybráno ' + count + ' z ' + total
	},
})

// Textarea clear
$(function () {
	const $textarea = $('#myTextarea')
	const $clearBtn = $('.clear-btn')

	$textarea.on('input', function () {
		if ($(this).val().length > 0) {
			$clearBtn.show()
		} else {
			$clearBtn.hide()
		}
	})

	$clearBtn.on('click', function () {
		$textarea.val('')
		$textarea.trigger('input')
		$textarea.focus()
	})
})

// Tippy
document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll('.custom-input__tooltip[data-original-title]').forEach(function (el) {
		tippy(el, {
			content: el.getAttribute('data-original-title'),
		})
	})
})

// Answer form actions

$('#get-verification-link-btn').click(function () {
	// $('.verification__status-message').show('slow')
	// $(this).addClass('is-disabled')
	$('.verification__type').show('slow')
})

$('#close-verification-message').click(function () {
	$('.verification__status-message').hide('slow')
	$('#get-verification-link-btn').hide()
	$('.verification__login').show()
})

$('.answer-form__login-btn').click(function () {
	// $(this).addClass('is-disabled')
})

// Registration form actions
$('.verification__registration-send-btn').click(function () {
	// $('.verification__status-message').show('slow')
	//$(this).addClass('is-disabled')
	$('.verification__type').show('slow')
})

$('#close-verification-message').click(function () {
	$('.verification__status-message').hide()
})
